import types from 'redux/types';

export const getUser = (data) => {
  return {
    type: types.REQUEST_USER,
    ...data,
  };
};
